export { default } from './HeaderView';



// WEBPACK FOOTER //
// ./src/components/views/HeaderView/index.js